import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=16c64c7e&"
import script from "./bind.vue?vue&type=script&lang=js&"
export * from "./bind.vue?vue&type=script&lang=js&"
import style0 from "./bind.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports